<!--
  @Author: DKing
  @Desc: 商户列表
  @Date: 2020-01-15
-->

<template>
  <div class="page-main" id="rateTable">
    <!--查询部分-->
    <div class="search-header">
      <div class="block-form-item">
        <div class="inline-form-item inline-small">
          <span class="small-label">商户ID :</span>
          <el-input
            placeholder="请输入内容"
            v-model="paramQueryTemp.cooperatorId"
            clearable
          ></el-input>
        </div>

        <div class="inline-form-item inline-small">
          <span class="small-label">商户名称 :</span>
          <el-input
            placeholder="请输入内容"
            v-model="paramQueryTemp.cooperatorName"
            clearable
          ></el-input>
        </div>

        <div class="inline-form-item inline-small">
          <span class="small-label">商户类型 :</span>
          <el-select
            v-model="paramQueryTemp.cooperatorType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in merchantListStatus"
              :label="item.label"
              :key="item.key"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>

    <!--查询按钮-->
    <div class="search-footer">
      <div class="inline-form-item inline-small">
        <!-- <span class="small-label">关联代理 :</span>
          <el-input placeholder="请输入内容" v-model="paramQueryTemp.upperAgent" clearable></el-input> -->
        <a class="btnFullColor margin-between" @click="clickQuery()">查询</a>
        <my-button-empty
          :paramsObj="paramQueryTemp"
          :fn="clickQuery"
          @initQueryDate="initQueryDate"
        ></my-button-empty>
      </div>
    </div>

    <!--列表-->
    <div class="list-body">
      <el-table :data="resDataList">
        <el-table-column
          label="商户ID"
          prop="cooperatorId"
          :width="tableWidth.tableWidthMax"
        >
        </el-table-column>
        <el-table-column
          label="商户名称"
          prop="cooperatorName"
          :width="tableWidth.tableWidthMax"
        >
        </el-table-column>

        <el-table-column
          label="商户类型"
          prop="cooperatorTypeDesc"
        ></el-table-column>

        <el-table-column label="所属行业" prop="industryName"></el-table-column>
        <!-- <el-table-column label="关联代理" prop="upperAgent"></el-table-column> -->

        <el-table-column label="操作">
          <template slot-scope="scope">
            <button
              class="btnNoBordeShortrBlue"
              @click="xhrGetShowRate(scope.row)"
            >
              查看费率
            </button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="paramQueryTemp.pageNum"
        :layout="pagination.layout"
        :total="resData.totalCount"
        :page-count="resData.totalPageCount"
        :page-size="pagination.pageSize"
      >
      </el-pagination>
    </div>

    <!-- 查看费率 -->
    <el-dialog
      :title="resRateInfo.computeMode == 3 ? '阶梯费率' : '固定费率'"
      :visible.sync="dialogVisible"
      @close="handleClose"
      :width="resRateInfo.computeMode == 3 ? '1000px' : '520px'"
    >
      <!-- 只能看到直属商户，看不到代理的了 -->
      <div
        v-if="rowCooperatorType !== 40 && resRateInfo.computeMode != 3"
        class="dialog-body"
      >
        <div class="title-block">
          <div class="table-title">
            费率类型：{{ resRateInfo.computeMode == 1 ? "外扣" : "内扣" }}
          </div>
          <div>商户名称: {{ resRateInfo.cooperatorName }}</div>
          <div>费率: {{ resRateInfo.distributeRate }}</div>
        </div>
      </div>

      <div class="rate_range" v-if="resRateInfo.computeMode == 3">
        <div class="name-title">商户名称: {{ resRateInfo.cooperatorName }}</div>
        <RateRange :data="rateRangeList" :issueData="mockObject"></RateRange>
      </div>
      <div slot="footer" class="footer">
        <span class="btnFullColor" @click="dialogVisible = false">确 认</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { PAGINATION, TABLE_COMMENT_WIDTH } from "../../service/businessConsts";
import { HTTP_CODE } from "../../../build/axios_constants";
import {
  checkNull,
  fenToYuan,
  formatPrice,
  fenToWanNoFixed
} from "../../filters/filters";
import costRateTable from "../../components/costRateTable";
import RateRange from "../../components/rateRange.vue";
export default {
  name: "coop-list",
  components: {
    "cost-rate-table": costRateTable,
    RateRange
  },
  data() {
    return {
      pagination: PAGINATION,
      tableWidth: TABLE_COMMENT_WIDTH,
      merchantListStatus: [
        { key: "10", value: "10", label: "集团商户" },
        { key: "20", value: "20", label: "集团子公司" },
        { key: "30", value: "30", label: "普通商户" },
        { key: "40", value: "40", label: "代理商" }
      ],
      paramQueryTemp: {
        pageNum: 1,
        pageSize: PAGINATION.pageSize,
        cooperatorId: "",
        cooperatorName: "",
        cooperatorType: "",
        batchAgentType: ""
      },
      paramQuery: {},
      resData: {},
      resDataList: [],
      dialogVisible: false,
      rowCooperatorType: "",

      dialogTitle: "阶梯费率",
      rateRangeList: [],
      mockObject: {},

      resRateInfo: {
        computeMode: 1,
        cooperatorName: "",
        distributeRate: ""
      }
    };
  },
  computed: {},

  created() {
    this.paramQueryTemp = this.$store.getters.getCoopList;
    if (this.$route.query.dateParam) {
      // 从首页跳转过来的，带参数
      console.log("时间参数，", this.$route.query.dateParam);
      this.paramQueryTemp.batchAgentType = this.$route.query.dateParam;
    } else {
      this.paramQueryTemp.batchAgentType = "";
    }
    this.clickQuery();
  },

  mounted() {},

  methods: {
    clickQuery() {
      this.paramQuery = { ...this.paramQueryTemp };
      this.xhrQueryList();
    },

    // 列表
    xhrQueryList() {
      this.$store.commit("setCoopList", this.paramQuery);
      this.$http.getCoopList(this.paramQuery).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resData = res.data;
          this.resDataList = res.data.list;

          for (let item of this.resDataList) {
            for (let obj of this.merchantListStatus) {
              if (item.cooperatorType == obj.value) {
                item.cooperatorTypeDesc = obj.label;
              }
            }
          }
        }
      });
    },

    // xhr -- 查看费率
    xhrGetShowRate(data) {
      console.log(data);
      this.rowCooperatorType = data.cooperatorType;
      this.resRateInfo.cooperatorName = data.cooperatorName;
      this.$http.getShowRate({ cooperatorId: data.cooperatorId }).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.$nextTick(() => {
            this.dialogVisible = true;
            this.resRateInfo.computeMode = res.data.computeMode;
            this.resRateInfo.distributeRate = res.data.distributeRate;
            if (res.data.computeMode == 3) {
              this.rateRangeList = !!res.data.cooperatorPhaseRules
                ? res.data.cooperatorPhaseRules.map(it => {
                    it.rateRange =
                      fenToWanNoFixed(it.lowerLimitAmount) +
                      "～" +
                      fenToWanNoFixed(it.upperLimitAmount);
                    return it;
                  })
                : [];
              this.mockObject = {
                customerCurrentMonthDistributeAmount: fenToYuan(
                  res.data.customerCurrentMonthDistributeAmount
                ),
                customerLastMonthDistributeAmount: fenToYuan(
                  res.data.customerLastMonthDistributeAmount
                )
              };
            }
          });
        }
      });
    },

    // 换页
    handleCurrentChange(val) {
      this.paramQueryTemp.pageNum = val;
      this.clickQuery();
    },

    // 清空查询
    initQueryDate() {
      this.dateTemp = "";
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#rateTable .dialog-body {
  width: 100%;
}
#rateTable .el-dialog__body {
  padding: 20px;
}
.table-title {
  margin-bottom: 10px;
}
// 弹窗
.title-block {
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
}
.name-title {
  margin-left: 20px;
  color: #272727;
}
</style>



// WEBPACK FOOTER //
// src/views/coopManage/coopList.vue